module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue4.5f122a40.jpg";